module.exports = __webpack_public_path__ + "static/code_is_art-large-white-logo-67e06dbb7fac3fcc06dbaa56e2fb2149.png";